export default "__VITE_ASSET__BsEQvl_0__"